import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { changeHouseId, changeRoomsCount } from '../../actions/layouts';
import { Layouts } from '../../components/Layouts';
import { getCurrentHouse, getLayoutsData, getCurrentRoomsCount } from '../../selectors/layouts';
import { getLayoutsHouses } from '../../selectors/newbuilding';
import { isLayoutExperimentEnable } from '../../selectors/offers';
import { ERoomsCount } from '../../types/newbuilding/layouts';
import { trackClick3DTourView, trackClickViewLayoutsOffersButton } from './tracking';

export function LayoutsContainer() {
  const dispatch = useDispatch();
  const houses = useSelector(getLayoutsHouses);
  const roomsCount = useSelector(getCurrentRoomsCount);
  const houseId = useSelector(getCurrentHouse);
  const layouts = useSelector(getLayoutsData);
  const isAbExperiments = useSelector(isLayoutExperimentEnable);

  const onOffersButtonClick = () => {
    trackClickViewLayoutsOffersButton();
  };

  const on3DTourTypeChange = () => {
    trackClick3DTourView();
  };

  const onChangeHouseId = React.useCallback(
    (houseId: number) => {
      dispatch(changeHouseId(houseId));
    },
    [dispatch],
  );

  const onChangeRoomsCount = React.useCallback(
    (roomsCount: ERoomsCount | undefined) => {
      dispatch(changeRoomsCount(roomsCount));
    },
    [dispatch],
  );

  if (!houses || !houses.length || isAbExperiments) {
    return null;
  }

  return (
    <Layouts
      houses={houses}
      layouts={layouts}
      currentRoom={roomsCount}
      currentHouse={houseId}
      onHouseChange={onChangeHouseId}
      onRoomChange={onChangeRoomsCount}
      onOffersButtonClick={onOffersButtonClick}
      on3DTourTypeChange={on3DTourTypeChange}
    />
  );
}
